// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1396":"a22a9b58","1576":"4a4c4488","3194":"a22a9b58","6534":"ce99d352"}[chunkId] + ".chunk.css";
};